const createNotificationLinks = (metadata) => Object.keys(metadata).map((key) => {
  if (key === 'unit_id') {
    return { name: 'Unit', link: `/unit/${metadata.unit_id}`}
  } else {
    return undefined
  }
}).filter(item => item !== undefined)

export default createNotificationLinks